<soho-expandable-area [closed]="false" [ngClass]="{'hide-show-more': true}">
  <soho-expandable-header>
    <div class="col-header-container" (click)="toggleHeaders($event)">
      <div class="col-header-title" (click)="toggleHeaders($event)">
        <svg soho-icon [icon]="buttonIcon()" class="icon collapsible-header-icon"></svg>
        <svg soho-icon [icon]="'folder'" class="lm-builder-field-folder-icon" ></svg>
        <p>{{label}}</p>
      </div>
    </div>
  </soho-expandable-header>
  <soho-expandable-pane>
    @for(field of fields; track field.label) {
      <div class="lm-builder-field-wrapper">
        <svg soho-icon class="lm-builder-field-drag" [icon]="'drag'" soho-tooltip [content]="'DragMe' | translate"/>
        <svg soho-icon class="lm-builder-field-icon" [icon]="field.icon" soho-tooltip [content]="field.type"/>
        <span class="lm-builder-field-label"><p>{{ field.label }}</p></span>
      </div>
    }
  </soho-expandable-pane>
</soho-expandable-area>
